module.exports = __webpack_public_path__ + "img/icon-arrow.86f09e23.svg";